/*
 * This is an example of how to nest functionality within the Hybrid module.
 * eg Usage
 *  BackOffice.Integration.DoStuff('something', 'something else');
 */

//  Shopify General
var Shopify = (function(backOffice, $){

    backOffice.Integration.Shopify = (function(){
        const storeModes = function(){
            return [
                { name: "new" },
                { name: "pending" },
                { name: "loading" },
                { name: "confirmation" },
                { name: "complete" }
            ];
        };

        return $.extend(backOffice.Integration.Shopify,
            {
                StoreModes: storeModes
            });
    })();

    return backOffice.Integration.Shopify;
})(BackOffice || {}, jQuery);

//  ShopifyIntegration.aspx
var ShopifyIntegration = (function(backOffice, $){

    backOffice.Integration.ShopifyIntegration = (function(){
        const scopeSelector = backOffice.options.scopeSelector;
        var integrationData;
        var titleDdlSelector;
        var seoTitleDdlSelector;
        var initialProductTitleMappingValue;
        var initialSeoProductTitleMappingValue;
        var salesOutletDdlSelector;
        var initialSalesOutletValue;
        var selectedInventoryLocations;
        var availableClickAndCollectLocations;
        var availableInventoryLocations;
        var selectedClickAndCollectLocations;
        var availablePriorityShippingLocations;
        var selectedPriorityShippingLocations;

        var initialInventoryLocationItems;
        var initialClickAndCollectLocationItems,
            clickAndCollectSettings;


        const initialise = function (options) {
            options.StoreModes = backOffice.Integration.Shopify.StoreModes();

            $.extend(backOffice.options, options);
            integrationData = options.integrationData;
            titleDdlSelector = options.titleDdlSelector;
            seoTitleDdlSelector = options.seoTitleDdlSelector;
            salesOutletDdlSelector = options.salesOutletDdlSelector;
            clickAndCollectSettings = options.clickAndCollectSettings;

            selectedInventoryLocations = options.selectedInventoryLocations;
            selectedClickAndCollectLocations = options.selectedClickAndCollectLocations;
            selectedPriorityShippingLocations = options.selectedPriorityShippingLocations;

            availableClickAndCollectLocations = options.availableClickAndCollectLocations;
            availableInventoryLocations = options.availableInventoryLocations;
            availablePriorityShippingLocations = options.availablePriorityShippingLocations;

            initialProductTitleMappingValue = titleDdlSelector[titleDdlSelector.selectedIndex].value;
            initialSeoProductTitleMappingValue = seoTitleDdlSelector[seoTitleDdlSelector.selectedIndex].value;
            initialSalesOutletValue = salesOutletDdlSelector[salesOutletDdlSelector.selectedIndex].value;
            initialClickAndCollectLocationItems = selectedClickAndCollectLocations ? selectedClickAndCollectLocations.querySelectorAll("span.rlbText") : null;
            initialInventoryLocationItems = selectedInventoryLocations.querySelectorAll("span.rlbText");
            if (options.priorityShippingEnabled === false) {
                events();
                handleClickAndCollectGoogleMapsApiVisibility();
            }
        },
        events = function () {
            let $keyContainer = $("#googleMapsApiKeyContainer");

            $("[name='ctl00$ContentPlaceHolder1$GoogleApiStatus']").on("change", function (e) {
                if (e.currentTarget.value == "true") {
                    $keyContainer.removeClass("hidden").addClass("IsRequired");
                } else {
                    $keyContainer.addClass("hidden").removeClass("IsRequired");
                }
            });

            $keyContainer.on("change", function () {
                if ($keyContainer.find("input[type=text]").val() == "") {
                    $(this).addClass("has-error");
                    $("#rfvGoogleMapsAPIKey").removeClass("hidden");
                } else {
                    $(this).removeClass("has-error");
                    $("#rfvGoogleMapsAPIKey").addClass("hidden");
                }
            });
        },
        handleClickAndCollectGoogleMapsApiVisibility = function () {
            let $keyContainer = $("#googleMapsApiKeyContainer");
            if (clickAndCollectSettings) {
            //  show the Google API Key field
                if (clickAndCollectSettings.map_enabled) {
                    $keyContainer.removeClass("hidden").addClass("IsRequired");
                } else {
                    $keyContainer.addClass("hidden").removeClass("IsRequired");
                }
            }
        };
        const clientChecks = function(){
            if (validate()){
                var selectedStatusEnabled = $("#rbStatusEnabled").is(":checked"),
                    googleMapsApiEnabled = $("#rbGoogleApiStatusRadioButtonEnabled").is(":checked"),
                    storeModes = backOffice.options.StoreModes,
                    pendingMode = storeModes.filter(function(storeModes){ return storeModes.name === "pending"; })[0],
                    completeMode = storeModes.filter(function (storeModes) { return storeModes.name === "complete"; })[0];

                let $keyContainer = $("#googleMapsApiKeyContainer");
                if (($keyContainer).hasClass("IsRequired") && $keyContainer.find("input[type=text]").val() == "") {
                    $keyContainer.addClass("has-error");
                    $("#rfvGoogleMapsAPIKey").removeClass("hidden");
                    return false;
                } else {
                    $keyContainer.removeClass("has-error");
                    $("#rfvGoogleMapsAPIKey").addClass("hidden");
                }

                // If a change has been made that requires a bulk sync then we need an additional modal to confirm
                var currentProductTitleMappingValue =
                    titleDdlSelector[titleDdlSelector.selectedIndex].value;
                var currentSeoProductTitleMappingValue =
                    seoTitleDdlSelector[seoTitleDdlSelector.selectedIndex].value;
                var currentSalesOutletValue =
                    salesOutletDdlSelector[salesOutletDdlSelector.selectedIndex].value;
                var currentInventoryLocationItems = selectedInventoryLocations.querySelectorAll(
                    "span.rlbText"
                );

                var currentClickAndCollectItems = selectedClickAndCollectLocations ? selectedClickAndCollectLocations.querySelectorAll("span.rlbText") : null;

                // We need to know if any inventory locations have changed, so do a count check and if the same then check each one individually
                var inventoryChanged = false;
                if (
                    currentInventoryLocationItems.length !==
                        initialInventoryLocationItems.length
                ){
                    inventoryChanged = true;
                }
                else{
                    for (var i = 0; i < initialInventoryLocationItems.length; i++){
                        var storeName = initialInventoryLocationItems[i].innerText;

                        var storeMatch = false;
                        for (var j = 0; j < currentInventoryLocationItems.length; j++){
                            if (currentInventoryLocationItems[j].innerText === storeName){
                                storeMatch = true;
                            }
                        }

                        if (storeMatch === false){
                            inventoryChanged = true;
                        }
                    }
                }
                
                var clickAndCollectChanged = false;
                if (currentClickAndCollectItems && initialClickAndCollectLocationItems) {  //  is click and collect visible/enabled
                    if (currentClickAndCollectItems.length > 0 && initialClickAndCollectLocationItems.length === 0) {
                        clickAndCollectChanged = true;
                    }
                }

                var hasChanged =
                    currentProductTitleMappingValue !==
                        initialProductTitleMappingValue ||
                        (currentSeoProductTitleMappingValue !==
                        initialSeoProductTitleMappingValue && currentSeoProductTitleMappingValue !== 'Do not Sync') ||
                        currentSalesOutletValue !== initialSalesOutletValue ||
                        inventoryChanged === true ||
                        clickAndCollectChanged === true;

                if (
                    hasChanged &&
                        integrationData.setup_status === completeMode.name
                ){
                    showFullSyncChangeModal(selectedStatusEnabled);
                    // The modal confirmation button will trigger the save, so don't allow save to carry on after this
                    return false;
                }
                else{
                    if (
                        !integrationData.enabled &&
                            selectedStatusEnabled &&
                            integrationData.setup_status === pendingMode.name
                    ){
                        // user changed from disabled to enabled and never been synced- redirect to loading via codebehind
                        return true;
                    }

                    if (integrationData.setup_status === completeMode.name){
                        if (selectedStatusEnabled && !integrationData.enabled){
                            //  changed from enabled to disabled
                            showStatusChangeModal(selectedStatusEnabled);
                            return false;
                        }

                        if (!selectedStatusEnabled && integrationData.enabled){
                            //  changed from disabled to enabled
                            showStatusChangeModal(selectedStatusEnabled);
                            return false;
                        }
                    }

                    return true;
                }
            }

            return false;
        };

        var showStatusChangeModal = function(selectedStatusEnabled){
                if (!selectedStatusEnabled){
                    $("#mdlSyncStatusBodyDisabled").css("display", "block");
                    $("#mdlSyncStatusBodyEnabled").css("display", "none");
                    $("#mdlSyncStatusTitle").text("Disable Synchronisation");
                }

                $("#mdlSyncStatus").modal({
                    show: true
                });
            },
            showFullSyncChangeModal = function(isIntegrationEnable){
                if (isIntegrationEnable){
                    $("#mdlFullSyncChangeEnabledConfirmation").modal({
                        show: true
                    });
                }
                else{
                    $("#mdlFullSyncChangeDisabledConfirmation").modal({
                        show: true
                    });
                }
            };

        var sortBox = function(boxToSort) {

            var sortedItemsArray = boxToSort.get_items().toArray().sort(function(a, b) {

                if (!a._text) {
                    a._text = a._element.innerText;
                }
                if (!b._text) {
                    b._text = b._element.innerText;
                }

                var textA = a._text.toUpperCase();
                var textB = b._text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            for (var i = 0; i < sortedItemsArray.length; i++) {
                boxToSort.reorderItem(sortedItemsArray[i], i);
            }
        };

        const clientEvents = {
            // The page is reloading and we have to hide the click and collect locations in the source box 
            onStart: function(sender) {
                const selectedInventoryLocationsListBox = $find(selectedInventoryLocations.id);

                sender.trackChanges();

                const items = sender.get_items();
                for (let i = 0; i < items.get_count(); i++) {

                    const cncItem = selectedInventoryLocationsListBox.findItemByText(items.getItem(i).get_text());

                    if (!cncItem) {
                        //Hide the location
                        items.getItem(i).set_visible(false);
                    }

                }
                sender.commitChanges();
            },
            onIntegrationTabChange: function(sender, eventArgs) {
                var notificationElements = document.querySelectorAll(".global-error-list .rex-notification-panel")
                for (var i = 0; i < notificationElements.length; i++) {
                    notificationElements[i].classList.add("hidden")
                }
            }

        };

        return $.extend(backOffice.Integration.ShopifyIntegration,
            {
                Init: initialise,
                ClientChecks: clientChecks,
                Events: clientEvents
            });
    })();

    return backOffice.Integration.ShopifyIntegration;
})(BackOffice || {}, jQuery);

//  ShopifyLoading.aspx
var ShopifyLoading = (function(backOffice, $){

    backOffice.Integration.ShopifyLoading = (function(){
        const scopeSelector = backOffice.options.scopeSelector;
        var currentStoreMode,
            integrationData;

        const initialise = function(options){
            options.StoreModes = backOffice.Integration.Shopify.StoreModes();
            options.loadingWaitTime = 5000;

            $.extend(backOffice.options, options);
            integrationData = options.integrationData;
            currentStoreMode = integrationData.setup_status;
            events();
            BackOffice.EventChannel.broadcast("ShopifyStorePollStarted");
        };
        var checkStore = function(){
                //  handle string comparisons in lower case. StoreModes object properties are already in lower case.
                const storeModes = backOffice.options.StoreModes;
                var confirmationMode = storeModes.filter(function(storeModes){
                    return storeModes.name === "confirmation";
                })[0];
                const url = `/Dotnet/admin/api/shopify/getStore/${integrationData.subdomain}`;

                $.get(url).done(function(storeData){
                    if (storeData.setup_status.toLowerCase() === confirmationMode.name){
                        BackOffice.EventChannel.broadcast(
                            "ShopifyStoreModeIsFinishedLoading",
                            storeData
                        );
                        return;
                    }
                });
            },
            events = function(){
                //  set up a timer to poll for changes - increment is set in options
                var timerId = setInterval(function(){ checkStore(); }, backOffice.options.loadingWaitTime);

                //  do something when polling begins
                BackOffice.EventChannel.subscribe(
                    "ShopifyStorePollStarted",
                    function(){ $("body").addClass("polling"); }
                );

                //  do something when store transitions from 'loading' mode
                BackOffice.EventChannel.subscribe(
                    "ShopifyStoreModeIsFinishedLoading",
                    function(storeData){
                        //  oops, broken
                        if (!storeData || !storeData.subdomain){
                            backOffice.DisplayErrorMessage();
                            return;
                        }

                        //  move on to store integration page
                        $("body").removeClass("polling");
                        location.href =
                            `ShopifyConfirmation.aspx?Integration_ID=${storeData.subdomain}`;
                        clearTimeout(timerId);
                    }
                );
            };

        return $.extend(backOffice.Integration.ShopifyLoading,
            {
                Init: initialise
            });
    })();

    return backOffice.Integration.ShopifyLoading;
})(BackOffice || {}, jQuery);